import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import { TrustBar, ServicesSection, CategoriesSection, WhySection, TestimonialsSection, CtaBanner } from '../components/sections/HomeSections';
import SearchSection from '../components/sections/SearchSection';
import ContactSection from './ContactPage';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <TrustBar />
      <SearchSection />
      <ServicesSection />
      <div style={{ height: 1, background: 'linear-gradient(90deg, transparent, var(--silver-light), transparent)' }} />
      <CategoriesSection />
      <WhySection />
      <TestimonialsSection />
      <CtaBanner />
      <ContactSection embedded />
    </>
  );
}
